export default __webpack_public_path__ + "static/media/calorie-icon.67f65cb5.svg";